import './urick/style';
import FormStructure from './urick/form_structure';

export default FormStructure;